// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/snail.js';

import { paths } from '../generated/snail';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('snail', Original, paths);
